import { computed } from 'vue'

// お客様情報の表は、表示する行の組み合わせで最後の行が変わる。
// 最後の行にだけ締めの線（form_line_l / form_line_r）を付けるための判定をまとめる
// （表の並び: … → 支払方法の行の直前の行 → 支払方法の行 → 案内文の行）
export const useClosingRow = (props) => {
  // 支払方法の行も案内文の行も表示しないときは、支払方法の行の直前の行が表の最後の行になる
  const isRowBeforePaymentMethodLast = computed(() => !props.showPaymentMethod && !props.showContactGuidance)

  // 案内文の行を表示しないときは、支払方法の行が表の最後の行になる
  const isPaymentMethodRowLast = computed(() => !props.showContactGuidance)

  return {
    isRowBeforePaymentMethodLast,
    isPaymentMethodRowLast,
  }
}
